import { gql } from '@apollo/client'

export const quoteLevelLeadTimesWithShippingOptionsQuery = gql`
    fragment QlltOption on QuoteLevelLeadTimeAndPriceOption {
        leadTimes
        shipByDate
        shippingOptions {
            shippingOptionId
            name
            deliveredByDate
        }
        subTotalInCents
    }

    query QuoteLevelLeadTimesWithShippingOptions(
        $quoteId: UUID!
        $address: AddressInput
    ) {
        quote(id: $quoteId) {
            id
            quoteLevelLeadTimesWithShippingOptions(address: $address) {
                domesticFastest {
                    ...QlltOption
                }
                domesticStandard {
                    ...QlltOption
                }
                domesticCostEffective {
                    ...QlltOption
                }
                overseasFastest {
                    ...QlltOption
                }
                overseasStandard {
                    ...QlltOption
                }
                overseasCostEffective {
                    ...QlltOption
                }
            }
        }
    }
`
